import { useState } from 'react';

const CopyBtn = ({ text }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            
            // 2초 후 원래 상태로 복원
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (err) {
            console.error('복사 실패:', err);
            // 복사 실패 시에도 잠깐 피드백 표시
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
        }
    }

    return (
        <button 
            type="button" 
            title={isCopied ? "복사됨!" : "복사"} 
            className={`copyBtn ${isCopied ? 'copied' : ''}`}
            onClick={handleCopy}
        >
            {isCopied ? (
                <svg 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    className="check-icon"
                >
                    <polyline points="20,6 9,17 4,12"></polyline>
                </svg>
            ) : (
                <i className="icon icon-copy"></i>
            )}
        </button>
    )
}

export default CopyBtn;